import { Container, Text } from '@chakra-ui/react'
import {
  AddressContactAndTransportation,
  ContentNotFound,
  Layout,
} from '@common'
import { ISSRPageData } from '@interfaces'
import { PageService } from '@services'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const ContactScreen = ({ pageData, global: { navigation } }: ISSRPageData) => {
  const { t } = useTranslation()
  const { asPath } = useRouter()

  if (pageData.error) {
    return (
      <Layout
        title={t('common:ssmPageTitle')}
        navigation={navigation}
        path={asPath}
      >
        <ContentNotFound infoType="serverSideError" />
      </Layout>
    )
  }

  return (
    <Layout
      title={t('explore-ssm:contact.pageTitle')}
      navigation={navigation}
      path={asPath}
    >
      <Container as="section" pt={{ base: '65px', lg: '70px' }}>
        <Text
          as="h2"
          fontSize={{ base: '2xl', lg: '3xl' }}
          color="red.primary"
          mb={{ base: 1, lg: '6px' }}
        >
          {pageData?.data?.hero?.subTitle || 'SSM'}
        </Text>
        <Text
          as="h1"
          fontSize={{ base: '4xl', lg: '5xl' }}
          color="black.primary3"
          opacity={0.8}
          lineHeight="shorter"
          fontWeight="bold"
        >
          {pageData?.data?.hero?.title || t('explore-ssm:contact.pageTitle')}
        </Text>
      </Container>
      {pageData?.data?.addressContact && (
        <AddressContactAndTransportation
          data={pageData?.data?.addressContact}
          stickyId={'contact'}
          containerProps={{
            pt: { base: 'padding.primary', lg: '20' },
            pb: { base: 'padding.primary2', lg: 'padding.primary4' },
            px: { base: 'padding.primary', lg: '0' },
          }}
        />
      )}
    </Layout>
  )
}

export default ContactScreen

export async function getStaticProps({ locale }) {
  const pageData = await PageService.getContactPage(locale)

  return {
    props: { pageData },
  }
}
